import { environment } from "environments/environment";
import { Component, OnInit, Renderer2, AfterViewInit } from "@angular/core";
import { PageService } from "app/services/page-service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "app/services/auth.service";
import { LocalService } from "app/services/local.service";
import { GlobalService } from "app/services/global.service";
import { RoleBasedAdminService } from "app/modules/role-based-admin/role-based-admin.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  submitted = false;
  errorMessage = "";
  loader = false;
  getUserData: any;
  loginDetails: any;
  userDetails: any;
  projectName = environment.projectName;
  validEmail = false;
  // password;
  // show = false;
  accessDetailsbymodule: any;
  apiUrl =
    localStorage.getItem("client") &&
    JSON.parse(localStorage.getItem("client")) &&
    JSON.parse(localStorage.getItem("client"))["apiUrl"]
      ? JSON.parse(localStorage.getItem("client"))["apiUrl"]
      : environment.apiUrl;
   loginLogo = environment.loginLogo
    defaultAccountUser: any;
    accountRoleId = "";
    permissionData: any;

  // currentSlide = 0;

loginSlides = [
  // {
  //   image: '../../assets/images/login-farm-1.png',
  //   title: 'Empowering Farmers.',
  //   description: 'Strengthening Communities. Building Sustainable Future.'
  // },
  // {
  //   image: '../../assets/images/login-farm-2.png',
  //   title: 'Growing Together.',
  //   description: 'Building Better Futures. Supporting Rural Communities.'
  // },
  {
    image: '../../assets/images/login-farm-3.png',
    title: 'From Farms to Markets.',
    description: 'Creating Sustainable Growth. Connecting Farmers to Opportunity.'
  }
];

showPassword = false;

// private loginSlideInterval: any;
  constructor(
    public renderer: Renderer2,
    public service: PageService,
    public authService: AuthService,
    public fb: FormBuilder,
    public router: Router,
    public localService: LocalService,
    public global: GlobalService,
    public roleService: RoleBasedAdminService,
  ) {}

  ngOnInit(): void {
    const modudelaccess = {
      id: "1",
      add: false,
      edit: false,
      view: true,
      delete: false,
      moduleAccessByUser: true,
    };
    this.accessDetailsbymodule = [
      {
        customer: modudelaccess,
      },
    ];
    const data = JSON.parse(localStorage.getItem("client"));
    if (data && data["projectName"]) {
      this.projectName = data["projectName"]; 
    }
    const getEmailID = localStorage.getItem("emailID");
    this.loginForm = this.fb.group({
      email: [
        getEmailID ? getEmailID : "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,5}$/),
        ],
      ],
      password: ["", Validators.required],
    });
    // this.password = "password";
    // this.createAccount();
    // this.startLoginSlider();
  }

  togglePasswordVisibility(): void {
  this.showPassword = !this.showPassword;
}

  get f() {
    return this.loginForm.controls;
  }
  ngAfterViewInit() {
    // let loader = this.renderer.selectRootElement('#loader');
    // loader.style.display = "none";
  }

  // createAccount() {
  //   const userDetails = {
  //     aggregatorAccount: {
  //       accountType: "ADMIN",
  //       emailID: "rakesh@pharoslife.in",
  //       password: "abcd@1234",
  //       contactNumber: "7205162267",
  //       firstName: "Rakesh",
  //       middleName: "",
  //       lastName: "Acharya",
  //     },
  //   };
  //   this.service
  //     .createAccount(userDetails)
  //     .then((data) => {})
  //     .catch((err) => {
  //       ////this.global.failureErrorModal(err);
  //     });
  // }
  onSubmit() {
    localStorage.removeItem("permissionData2");
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
   const data = {
      email: this.loginForm.get("email").value,
      password: this.loginForm.get("password").value,
    };
    this.loader = true;
    this.errorMessage = "";
    this.service
      .loginUser(data, this.apiUrl)
      .then((data) => {
        console.log(data);
        localStorage.removeItem("emailID");
        localStorage.setItem("token", data['data']["accessToken"]);
        localStorage.setItem("userDetails", JSON.stringify(data['data']["user"]));
        this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
        console.log(this.userDetails);
        // this.loader = false;
        if (
          this.userDetails
        ) {
          this.router.navigate(["/dashboard"]);
        } else {
          setTimeout(() => {
            this.loader = false;
            this.router
              .navigate(["/dashboard"])
              .then(() => window.location.reload());
          }, 1000);
        }
      })
      .catch((err) => {
        console.log(err);
        const errMsg =
          err["error"] && err["error"]["status"] === 0
            ? err["error"]["message"]
            : "Sorry! Invalid Email or Password Entered";
        ////this.global.failureErrorModal(errMsg);
        this.loader = false;
        this.errorMessage = "Invalid Email or Password";
      });
  }

  getClientInfo() {
    this.errorMessage = "";
    const getEmailID = localStorage.getItem("emailID");
    const emailID = this.loginForm.get("emailID").value;
    this.validEmail = false;
    if (emailID.length > 0) {
      this.loader = true;
      this.service
        .getClientDetails({
          email: emailID,
        })
        .then((data) => {
          this.loader = false;
          console.log(data);
          const details = data["data"];
          if (details["name"]) {
            this.validEmail = true;
            localStorage.setItem("clientName", details["name"]);
            localStorage.setItem("emailID", emailID);
            this.apiUrl = details["apiUrl"]; //"http://localhost:3000/"; ;;;
            // this.apiUrl = details["apiUrl"];
            // this.apiUrl = "http://localhost:3000/";
            localStorage.setItem(
              "client",
              JSON.stringify({
                CURRENCY: details["currency"],
                apiUrl: this.apiUrl,
                colors: details["colors"],
                countryCode: details["countryCode"],
                logo: details["logo"],
                projectName: details["displayName"],
                name: details["name"],
                separator: " | ",
                showDevelopedBy: false,
              }),
            );
          } else {
            this.loader = false;
            localStorage.removeItem("clientName");
            localStorage.removeItem("client");
            this.errorMessage = "Sorry! Email ID is not registered with us.";
          }
        })
        .catch((err) => {
          this.loader = false;
          localStorage.removeItem("clientName");
          localStorage.removeItem("client");
          this.errorMessage = "Sorry! Email ID is not registered with us.";
          console.log(err);
        });
    } else {
      localStorage.removeItem("clientName");
      localStorage.removeItem("client");
      this.loader = false;
    }
  }

  getAccessRole(id) {
    const data = {
      roleID: id,
    };
    this.roleService.getAccessRole(data).then((response) => {
      const roleData = response["data"];
      this.permissionData = this.transformPermissionData(
        response["data"]["permissions"],
      );

      if (this.permissionData) {
        localStorage.setItem(
          "permissionData",
          JSON.stringify(this.permissionData),
        );
      }
      if (
        roleData["role"] &&
        roleData["role"]["city"] &&
        roleData["role"]["city"]["countryCode"]
      ) {
        localStorage.setItem(
          "selectedCityData",
          JSON.stringify(roleData["role"]["city"]),
        );
        const orderCheck =
          this.permissionData["Order"]["view"] ||
          this.permissionData["Order"]["edit"] ||
          this.permissionData["Order"]["add"] ||
          this.permissionData["Order"]["delete"];
        if (orderCheck) {
          setTimeout(() => {
            this.loader = false;
            this.router
              .navigate(["/orders"])
              .then(() => window.location.reload());
          }, 1000);
        } else {
          setTimeout(() => {
            this.loader = false;
            this.router
              .navigate(["/sellers"])
              .then(() => window.location.reload());
          }, 1000);
        }
      } else {
        setTimeout(() => {
          this.loader = false;
          this.router
            .navigate(["/dashboard"])
            .then(() => window.location.reload());
        }, 1000);
      }
    });
  }

  transformPermissionData(permissionsArray: any[]): any {
    // console.log(permissionsArray)
    const transformedData = {};

    permissionsArray.forEach((module) => {
      transformedData[module.moduleName] = {};

      module.permissions.forEach((permission) => {
        transformedData[module.moduleName][permission.name] =
          permission.permission !== 0;
      });
    });

    return transformedData;
  }

  // onClick() {
  //   if (this.password === "password") {
  //     this.password = "text";
  //     this.show = true;
  //   } else {
  //     this.password = "password";
  //     this.show = false;
  //   }
  // }

//   goToSlide(index: number){
//   this.currentSlide = index;

//   this.restartLoginSlider();
// }

//  startLoginSlider() {
//   this.loginSlideInterval = setInterval(() => {
//     this.currentSlide =
//       (this.currentSlide + 1) % this.loginSlides.length;
//   }, 5000);
// }
// restartLoginSlider() {
//   if (this.loginSlideInterval) {
//     clearInterval(this.loginSlideInterval);
//   }

//   this.startLoginSlider();
// }
}
